<comp-dialog>
  <ng-container comp-dialog-header-title>
    @if (isEditing()) {
      {{ 'requirementIntake.details.findings.edit' | translate }}
    } @else {
      {{ 'model.finding.singular' | translate }}
    }
  </ng-container>
  <ng-container comp-dialog-header-action-items>
    @if (data().finding.type == 'MANUAL' && !isEditing()) {
      <comp-card-buttons>
        <ng-container ngProjectAs="[left]">
          <button comp-button="tertiary" type="button" (click)="onEdit()">
            <i comp-icon>edit</i>
            {{ 'general.edit' | translate }}
          </button>
          <button comp-button="tertiary" action="delete" type="button" (click)="onDelete()">
            <i comp-icon>delete</i>
            {{ 'general.delete' | translate }}
          </button>
        </ng-container>
      </comp-card-buttons>
    }
  </ng-container>
  @if (data().isAIgenerated) {
    <ng-container comp-dialog-content compAiGeneratedContentDisclaimer>
      <ng-container *ngTemplateOutlet="findingContent"></ng-container>
    </ng-container>
  } @else {
    <ng-container comp-dialog-content>
      <ng-container *ngTemplateOutlet="findingContent"></ng-container>
    </ng-container>
  }
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        @if (!needsSave()) {
          <button comp-button="tertiary" type="button" mat-dialog-close>
            {{ 'general.close' | translate }}
          </button>
        } @else {
          <button comp-button="secondary" type="button" (click)="onCancelEdit()">
            {{ 'general.cancel' | translate }}
          </button>
          <button comp-button action="save" type="submit" form="edit-finding-form">
            {{ 'general.save' | translate }}
          </button>
        }
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>

<ng-template #findingContent>
  <comp-scrollable-card>
    @if (needsSave()) {
      <form id="edit-finding-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <comp-grid-table [tableContent]="tableContent()"></comp-grid-table>
      </form>
    } @else {
      <comp-grid-table [tableContent]="tableContent()"></comp-grid-table>
    }
  </comp-scrollable-card>
</ng-template>

<ng-template #nameTemplate>
  <comp-finding-name [finding]="data().finding"></comp-finding-name>
</ng-template>

<ng-template #nameEditTemplate>
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="ul-single-line-input outlined-form-element inline-edit-field"
  >
    <input
      [formControl]="nameControl"
      matInput
      required
      [errorStateMatcher]="dirtyErrorStateMatcher"
    />
    @if (nameControl.hasError('required')) {
      <mat-error>{{ 'general.validation.required' | translate }}</mat-error>
    }
    @if (nameControl.hasError('maxlength')) {
      <mat-error>
        {{
          'general.validation.maxlength'
            | translate: { length: nameControl.getError('maxlength')?.requiredLength }
        }}
      </mat-error>
    }
  </mat-form-field>
</ng-template>

<ng-template #severityTag>
  <comp-severity-tag [severity]="data().finding.severity"></comp-severity-tag>
</ng-template>

<ng-template #severityEditTemplate>
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="ul-single-line-input outlined-form-element inline-edit-field"
  >
    <mat-select panelWidth="auto" [formControl]="severityControl">
      @for (severity of severityOptions(); track severity.ident) {
        <mat-option [value]="severity.ident">{{ severity.labelKey | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #status>
  <comp-finding-state
    [finding]="data().finding"
    (findingChange)="onStatusChanged($event)"
  ></comp-finding-state>
</ng-template>

<ng-template #statusJustification>
  <div class="ul-inline-alert -info">
    {{ data().finding.statusJustification }}
  </div>
</ng-template>

<ng-template #findingDescription let-confidence="confidence" let-met="criterionMet">
  @if (confidence !== undefined) {
    <comp-criteria-analysis-result
      [criterionMet]="met"
      [confidence]="confidence"
    ></comp-criteria-analysis-result>
  }
  <markdown [data]="data().finding.description"></markdown>
</ng-template>

<ng-template #findingDescriptionEditTemplate>
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="ul-textarea-field outlined-form-element inline-edit-field inline-edit-textarea"
  >
    <textarea [formControl]="descriptionControl" matInput></textarea>
  </mat-form-field>
</ng-template>

<ng-template #cwesTemplate>
  <comp-finding-cwes [finding]="data().finding"></comp-finding-cwes>
</ng-template>
